import { StudentUserListView } from './StudentUserListView.model';
export class StudentUserView {
    StudentUserListView: StudentUserListView[]; }